export const ADYEN_ERROR_TYPES = {
  EQUIPMENT_NOT_EXIST: "Specified equipment does not exist",
  BUSINESS_PARTNER_NOT_EXIST: "Specified business partner does not exist",
};

export const AdyenErrorMessages = {
  [ADYEN_ERROR_TYPES.EQUIPMENT_NOT_EXIST]: {
    fr: "Votre concessionnaire n'a pas accès au produit dans le système. Veuillez contacter support@hcs.husqvarnagroup.com afin qu'ils puissent vous aider à l'ajouter. Veuillez nous excuser pour la gêne occasionnée.\nHCS a été informé de l'erreur et vous contactera dès que vous serez prêt à réessayer.",
    en: "Your dealership does not have access to product in the system. Please contact support@hcs.husqvarnagroup.com so they can help you get it added. Sorry for the inconvenience.\nHCS has been notified of the error and will contact you as soon as you're ready to try again.",
    de: "Ihr Autohaus hat im System keinen Zugriff auf dieses Produkt. Bitte wenden Sie sich an support@hcs.husqvarnagroup.com, damit man Ihnen dabei helfen kann, es hinzuzufügen. Wir entschuldigen uns für die Unannehmlichkeiten.\nHCS wurde über den Fehler informiert und wird sich mit Ihnen in Verbindung setzen, sobald Sie bereit sind, es erneut zu versuchen.",
    se: "Din återförsäljare har inte tillgång till produkten i systemet. Vänligen kontakta support@hcs.husqvarnagroup.com så att de kan hjälpa dig att lägga till den. Vi ber om ursäkt för besväret.\nHCS har fått kännedom om felet och kommer att kontakta dig så snart du är redo att försöka igen.",
    no: "Forhandleren din har ikke tilgang til produktet i systemet. Ta kontakt med support@hcs.husqvarnagroup.com, så kan de hjelpe deg med å få det lagt til. Beklager ulempen.\nHCS har blitt informert om feilen og vil kontakte deg så snart du er klar til å prøve på nytt.",
  },
  [ADYEN_ERROR_TYPES.BUSINESS_PARTNER_NOT_EXIST]: {
    fr: (customerNumber) =>
      `Le numéro Husqvarna fourni ${customerNumber} ne correspond à aucune entrée dans la base de données. Veuillez saisir un numéro Husqvarna valide.S'il s'agit de votre première commande auprès de HCS, veuillez utiliser l'ancien portail.`,
    en: (customerNumber) =>
      `The provided Husqvarna number ${customerNumber} does not match anything in the database. Please enter a valid Husqvarna number. If this is your first order with HCS, please use the old portal.`,
    de: (customerNumber) =>
      `Die angegebene Husqvarna-Nummer ${customerNumber}  ist in der Datenbank nicht zu finden. Bitte geben Sie eine gültige Husqvarna-Nummer ein. Wenn dies Ihre erste Bestellung bei HCS ist, nutzen Sie bitte das alte Portal.`,
    se: (customerNumber) =>
      `Den angivna Husqvarna-numret ${customerNumber} finns inte i databasen. Ange ett giltigt Husqvarna-nummer. Om detta är din första beställning hos HCS, använd den gamla portalen.`,
    no: (customerNumber) =>
      `Det oppgitte Husqvarna-nummeret ${customerNumber} finnes ikke i databasen. Vennligst oppgi et gyldig Husqvarna-nummer. Hvis dette er din første bestilling hos HCS, må du bruke den gamle portalen.`,
  },
};

export function getAdyenErrorMessage(errorMessage, lang, customerNumber) {
  const errorKey = Object.keys(AdyenErrorMessages).find((key) =>
    errorMessage.includes(key),
  );

  if (!errorKey) {
    return errorMessage;
  }

  const messageTemplate =
    AdyenErrorMessages[errorKey][lang] || AdyenErrorMessages[errorKey]["en"];

  return typeof messageTemplate === "function"
    ? messageTemplate(customerNumber)
    : messageTemplate;
}
